import { Injectable } from '@angular/core';
import { BehaviorSubject ,  Observer ,  Subscription } from 'rxjs';

@Injectable()
export class VideoService {

	private videoId: string = null;

	private loadSubject: BehaviorSubject<string>;
	private playSubject: BehaviorSubject<string>;
	private pauseSubject: BehaviorSubject<string>;

	constructor() {
		this.loadSubject = new BehaviorSubject<string>( null );
		this.playSubject = new BehaviorSubject<string>( null );
		this.pauseSubject = new BehaviorSubject<string>( null );
	}

	public currentVideoId(): string {
		return this.videoId;
	}

	public load( videoId: string ): void {

		if ( this.currentVideoId() === videoId ) {
			return;
		}

		this.videoId = videoId;
		this.loadSubject.next( videoId );

	}

	public play( videoId?: string ): void {

		if ( videoId ) {
			this.load( videoId );
		}

		if ( this.currentVideoId() ) {
			this.playSubject.next( this.currentVideoId() );
		}
	}

	public pause(): void {
		if ( this.currentVideoId() ) {
			this.pauseSubject.next( this.currentVideoId() );
		}
	}

	public onLoad( observer: Observer<string> ): Subscription {
		return this.loadSubject.subscribe( observer );
	}

	public onPlay( observer: Observer<string> ): Subscription {
		return this.playSubject.subscribe( observer );
	}

	public onPause( observer: Observer<string> ): Subscription {
		return this.pauseSubject.subscribe( observer );
	}


}
